module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfilledOrderMod"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v("您有未完成的" + _vm._s(_vm.title) + "订单")])]), _vm._v(" "), _c('div', {
    staticClass: "List"
  }, [_c('div', _vm._l((_vm.data ? _vm.data : null), function(time, index) {
    return _c('xk-record-order-mod', {
      key: index,
      attrs: {
        "startAddress": time.startAddress,
        "endAddress": time.endAddress,
        "serverTime": time.serverTime,
        "status": time.status,
        "orderId": time.orderId
      },
      on: {
        "recordOrderModClick": _vm.actionFn
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.modalFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.modalFn
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-917c3fc2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/unfilledOrderMod/src/unfilledOrderMod.vue
// module id = 555
// module chunks = 0